export const HIGHLIGHT_TAG_NAME = 'mark';

const highlightText = (text) => `<${HIGHLIGHT_TAG_NAME}>${text}</${HIGHLIGHT_TAG_NAME}>`;

const findBestMatch = (words) => (stats, displayWord) => {
  let { smallestMatchDifference, match } = stats;
  const matchingWords = words
    .filter((word) => displayWord.toLowerCase().includes(word.toLowerCase()));

  if (matchingWords.length) {
    // find the word that is the closest in length to the displayWord
    matchingWords.forEach((matchingWord) => {
      const matchDifference = displayWord.length - matchingWord.length;
      if (matchingWord && matchDifference < smallestMatchDifference) {
        smallestMatchDifference = matchDifference;
        match = matchingWord;
      }
    });
  }

  return { smallestMatchDifference, match };
};

/**
 * Formats a given text, highlighting the given `displayText` substring
 * and ensuring there are at most two parts to the string - a non-highlighted part,
 * EITHER before OR after the highlighted part.
 *
 * @param {string} text full expansion query text
 * @param {string} displayText the substring which is to be highlighted
 * @returns valid HTML string
 */
export const formatQueryExpansionText = (text, displayText) => {
  let fullText = text;
  let displayIndex = fullText.indexOf(displayText);
  if (displayIndex < 0) {
    // it's possible Bing will return a displayText that isn't
    // formatted the same as the substring of the original text
    // in this case, we try to find words in the full query which
    // match the displayText, and select the best match based on word length difference.
    // We then replace the match with the displayText and proceed with the algorithm.
    const words = fullText.split(' ');
    const displayWords = displayText.split(' ');
    const { match } = displayWords.reduce(
      findBestMatch(words),
      { smallestMatchDifference: Infinity, match: null },
    );

    if (match) {
      fullText = text.replace(match, displayText);
      displayIndex = fullText.indexOf(displayText);
    } else {
      // if no words match the displayText, the best we can do is
      // to show the full highlighted query
      return highlightText(fullText);
    }
  }
  const endOfDisplayIndex = displayIndex + displayText.length;
  if (displayIndex > 0 && fullText.length > endOfDisplayIndex) {
    // this handles the edge case when a highlighted `displayText`
    // is surrounded by two non-highlighted parts of the query
    // then we highlight everything up to the end of the highlighted text,
    // ensuring we always have two lines of text
    return highlightText(fullText.slice(0, endOfDisplayIndex)) + fullText.slice(endOfDisplayIndex);
  }
  return fullText.replace(displayText, highlightText(displayText));
};


export const encodeQueryExpansion = (expansion) => encodeURIComponent(JSON.stringify(expansion));
export const decodeQueryExpansion = (expansion) => JSON.parse(decodeURIComponent(expansion));
